import styled from 'styled-components';
import {palette} from '@/styles';
import AiIconSvg from './assets/ai-icon.svg';

export const ScrollBody = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 16px 16px 80px;
  font-weight: 400;
  line-height: 2;
  font-size: 14px;
  color: ${palette.grayBlack};
`;

export const AiIcon = styled.div`
  background-image: url(${AiIconSvg});
  background-position: center;
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const BlueInfoText = styled.div`
  color: #2a76fc;
  font-weight: 500;
`;

export const CircleIconButton = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  cursor: pointer;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${palette.bgTeal100};
  }
`;
